<template>
  <div class="app-container">
    <!--查询组-->
    <div class="filter-container">
      <el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
        <el-form-item prop="search">
          <el-input
            v-model="listQuery.search"
            placeholder="请输入角色名称"
            clearable
            @keyup.enter.native="SearchData"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="SearchData">
            搜索
          </el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--动作组-->
    <div class="action-container">
      <el-button-group>
        <!-- 弹窗层编辑 -->
        <router-link
          v-auth="'Role.create'"
          class="el-button el-button--primary el-button--medium action-item"
          :to="'/sys/role_edit'"
        >
          <i class="el-icon-edit" /> 添加
        </router-link>
        <!-- <el-button class="action-item" type="primary" icon="el-icon-edit"><router-link :to="'/system/role_edit'">添加</router-link></el-button> -->
        <el-button
          v-auth="'Role.delete'"
          class="action-item"
          icon="el-icon-delete"
          @click="BatchDelete"
        >
          删除
        </el-button>
      </el-button-group>
    </div>
    <!--表开始-->
    <el-table
      ref="singleTable"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @sort-change="sortChange"
    >
      <el-table-column type="selection" />
      <el-table-column
        align="center"
        prop="name"
        label="角色名称"
        style="text-align:center;"
        show-overflow-tooltip
      />
      <!-- <el-table-column prop="is_system" label="类型">
        <template slot-scope="{ row }">
          <el-tag v-if="row.is_system == 1">
            超级管理员
          </el-tag>
          <el-tag v-else type="success">
            系统用户
          </el-tag>
        </template>
      </el-table-column> -->
      <el-table-column
        align="center"
        prop="create_time"
        width="180"
        label="创建时间"
      />
      <el-table-column align="center" prop="" label="操作">
        <template slot-scope="scopes">
          <el-button
            v-auth="'Role.edit'"
            type="primary"
            plain
            size="mini"
            icon="el-icon-edit"
            @click="goDetail(scopes.row)"
          >
            编辑
          </el-button>
          <el-button
            v-if="scopes.row.id != 26 && scopes.row.is_system != 1"
            v-auth="'Role.delete'"
            size="mini"
            type="danger"
            icon="el-icon-delete"
            @click="RowDelete(scopes.row)"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
      <!--列结束-->
    </el-table>
    <!--分页-->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="listQuery.page"
      :limit.sync="listQuery.limit"
      @pagination="loadData"
    />
    <!--弹窗编辑/新增窗体-->
    <el-dialog
      :title="dialogStatus == 'create' ? '新增' : '编辑'"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        ref="dataForm"
        :rules="rules"
        :model="temp"
        label-position="left"
        label-width="70px"
        style="width: 400px; margin-left:50px;"
      >
        <el-form-item label="类型" prop="is_system">
          <el-select
            v-model="temp.is_system"
            placeholder="请选择"
            @change="changeSystem"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input v-model="temp.name" />
        </el-form-item>
        <el-form-item label="模块">
          <el-tree
            ref="tree"
            :data="data"
            empty-text="暂无模块"
            :props="props"
            node-key="id"
            show-checkbox
            @check-change="nodeChange"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="ConfirmData">
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api/role' // 和数据交互相关写在api 方便复用
// import menu from '@/api/module'// 角色模块接口
import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
import commonList from '@/utils/commonList'

export default {
  name: 'RoleList',
  components: { Pagination },
  // 列绑定格式化器
  filters: {},
  mixins: [commonList],
  data() {
    return {
      // api接口方法
      api,
      // 校验
      rules: {
        name: [{ required: true, message: '请输入角色名称', trigger: 'blur' }]
      },
      options: [
        { value: 1, label: '超级管理员' },
        { value: 0, label: '系统用户' }
      ],
      props: {
        label: 'title'
      },
      temp: {},
      data: {}
    }
  },
  created() {
    this.loadData() // 页面加载创建时加载数据
    // this.loadModule()
  },
  methods: {
    // 角色模块
    // loadModule() {
    //   this.menu.getAll().then(response => {
    //     this.data = response.data
    //   })
    // },
    // 新增
    goDetail(row) {
      this.$router.push(`/sys/role_edit?id=${row.id}`)
    },
    HandleCreate() {
      this.resetTemp()
      this.temp.is_system = this.options[0].value
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.changeSystem()
    },
    // 选择类型（判断是否全选）
    changeSystem(val) {
      this.$forceUpdate()
      this.$nextTick(() => {
        this.setAllStatus(this.data, this.temp.is_system === 1)
      })
    },
    setAllStatus(data, isdisabled) {
      data.forEach(node => {
        this.$set(node, 'disabled', isdisabled)
        this.$refs.tree.setChecked(node.id, isdisabled)
        if (node.children) {
          this.setAllStatus(node.children, isdisabled)
        }
      })
    },
    // 获取树形结构模块
    nodeChange(data) {
      this.temp.moduleList = this.$refs.tree
        .getCheckedKeys()
        .concat(this.$refs.tree.getHalfCheckedKeys())
    },
    // 修改
    HandleUpdate(row) {
      this.changeSystem()
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      // this.menu.getSelected({ id: row.id }).then(response => {
      //   this.temp = Object.assign({}, row) // copy obj
      //   this.temp.is_system = row.is_system
      //   this.changeSystem()
      //   this.dialogStatus = 'update'
      //   this.dialogFormVisible = true
      //   this.$nextTick(() => {
      //     response.data.forEach(item => {
      //       const node = this.$refs.tree.getNode(item.id)
      //       if (node.isLeaf) {
      //         this.$refs.tree.setChecked(item.id, true)
      //       }
      //     })
      //   })
      // })
    },
    // 提交删除
    BatchDelete() {
      if (this.$refs.singleTable.selection.length > 0) {
        var ids = this.$refs.singleTable.selection.map(
          a => a[this.primary_key]
        )
        const index = ids.findIndex(item => {
          if (item === 26 || item === 22) {
            return true
          }
        }) // 根据条件查找符号条件对象下标索引

        if (index > -1) {
          this.$message({
            message: '存在不能删除的数据，请修改',
            type: 'warning'
          })
          return false
        }
        this.$confirm('确定要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.api.Delete(ids).then(response => {
              this.$message({ message: '操作成功', type: 'success' })
              this.SearchData() // 重新加载数据
            })
          })
          .catch(() => {})
      } else {
        this.$message({ message: '请选择删除的数据', type: 'error' })
      }
    }
  }
}
</script>
